import { SRM_FILE_PRE } from '../../../constant/constant.js';

export const roundQuoteData = {
    showAddSupplier: false,
    IS_WS_LIVE_TIMER: null,
    IS_WS_TIMEOUT_TIMER: null,
    currentList: [],
    websock: null,
    seeOfferVisible: false,
    countTimes: '',
    cuuntdownSeconds: '',
    countTimesFlag: false,
    setIntervalTime: null,
    selectAllType: false,
    currentStartIndex: 0,
    currentEndIndex: 20,
    tableLoad: false,
    nextRoundLaod: false,
    publishDataLoad: false,
    bidPriceLoad: false,
    startTenderLoad: false,
    bidShortlistLoad: false,
    winBidLoad: false,
    warnShowFlag: false,
    loadHeadSave: false,
    loadNot: false,
    loadAbandon: false,
    loadSave: false,
    roundCard: [],
    moveX: 0,
    active: 0,
    focusIndex: 0,
    form: {
        effectDateFrom: '',
        effectDateTo: '',
        lowerLastRound: '',
        quoteType: '',
        changeBidMin: '',
        quotePrecision: 0,
        rankVisible: '',
        lowestQuoteVisible: '',
        currentSuppliers: '',
        supplierQuote: '',
        blockPriceControl: ''
    },
    tableData: [], // 表格数据
    tableIds: [], // 表格数据id集合
    tableHeaders: [],
    bidNo: '',
    statusBtn: false,
    timeBtn: false,
    nextBtn: false,
    bidPriceBtn: false,
    dictData: {},
    showAddTimeDialog: false,
    showBatchBidDialog: false,
    showAutoShortlist: false,
    showWonFailedDialog: false,
    showConsultCostDialog: false,
    loadConsultCostDialog: false,
    selectedDetails: [],
    selectedBtn: [],
    headerMsg: {},
    currentDetails: { url: `${SRM_FILE_PRE}/bid/exportBidTender/`, allowQuote: 'Y', loading: 'cdLoading', bigData: 'bigData-btn-exCurDetail' },
    allDetails: { url: `${SRM_FILE_PRE}/bid/exportBidTender/`, allowQuote: 'ALL', loading: 'adLoading', bigData: 'bigData-btn-exAllDetail' },
    currentResult: { url: `${SRM_FILE_PRE}/bid/exportBidTenderResult/`, allowQuote: 'Y', loading: 'crLoading', bigData: 'bigData-btn-exCurResult' },
    allResult: { url: `${SRM_FILE_PRE}/bid/exportBidTenderResult/`, allowQuote: 'ALL', loading: 'arLoading', bigData: 'bigData-btn-exAllResult' },
    exportNowScore: { url: `${SRM_FILE_PRE}/bid/exportBidTenderScoreResult/`, allowQuote: 'Y', loading: 'nsLoading' },
    exportAllScore: { url: `${SRM_FILE_PRE}/bid/exportBidTenderScoreResult/`, allowQuote: 'ALL', loading: 'asLoading' },
    allowQuote: 'Y',
    extStr1s: '',
    tenderStatus: '',
    shortlist: '',
    supplierName: '',
    value: '',
    selectedRow: [],
    showCustem: false,
    consultCostParams: {},
    standardCostLoading: false,
    cdLoading: false,
    adLoading: false,
    crLoading: false,
    arLoading: false,
    nsLoading: false,
    asLoading: false
};